import $ from "jquery";

export default function() {
  let menuOpen = false;

  function openMenu() {
    $("#mega-menu").addClass("active");
    menuOpen = true;
  }

  function closeMenu() {
    $("#mega-menu").removeClass("active");
    $("#mega-menu-men").removeClass("active");
    $("#mega-menu-women").removeClass("active");
    menuOpen = false;
  }

  $("#nav-men").hover(function() {
    if (menuOpen === false) {
      openMenu();
    }

    if ($("#mega-menu-women").hasClass("active")) {
      $("#mega-menu-women").removeClass("active");
    }

    $("#mega-menu-men").addClass("active");
  });

  $("#nav-women").hover(function() {
    if (menuOpen === false) {
      openMenu();
    }

    if ($("#mega-menu-men").hasClass("active")) {
      $("#mega-menu-men").removeClass("active");
    }

    $("#mega-menu-women").addClass("active");
  });

  $(".not-mega-menu").hover(function() {
    closeMenu();
  });

  $(".mega-menu__close").click(function() {
    closeMenu();
  });

  $(".mega-menu__site-overlay").hover(function() {
    closeMenu();
  });
}
